module.exports = __webpack_public_path__ + "static/estrategia-484d35f468fc79c9bd7a40e77411e7e6.png";